import axios from 'axios'
import apiConstant from './common/index'
import * as $utils from '../js/utils'               // 公共自定义钩子函数
import store from '../../store'
import Router from '../../router/index'
// import SignOut from '../../plugin/LeonSignOut'
import SimpleLogin from '../../plugin/LeonSimpleLogin'
import Message from '../../plugin/LeonMessage'
function setCookie(cname, cvalue) {
  document.cookie = `${cname}=${cvalue};Path=/;domain=${location.hostname}`
}
function getParam(url) {
  let param = url.split('?')[1]
  let param2 = new URLSearchParams('?' + param)
  // console.log(param2.get('taskRelationId'), 'param2')
  return param2
}
// import Config from '../config/version'
let ctype = (window && window.__wxjs_environment === 'miniprogram') ? 5 : 3
// axios.interceptors.response.use(res => {
//   // console.log(Config.version, res.headers['bloom-v'])
//   if (res && res.headers && res.headers['bloom-v']) {
//     // 如果缓存存在
//     if ($utils.cache('version')) {
//       if ($utils.cache('version') !== res.headers['bloom-v']) {
//         $utils.cache('version', res.headers['bloom-v'])
//         // console.log($utils.cache('version'))
//         window.location.reload(true)
//       }
//     } else {
//       // 没有缓存
//       if (Config.version !== res.headers['bloom-v']) {
//         $utils.cache('version', res.headers['bloom-v'])
//         // console.log($utils.cache('version'))
//         window.location.reload(true)
//       }
//     }
//   }
//   return res
// }, err => {
//   return Promise.reject(err)
// })

axios.interceptors.request.use(config => {
  axios.defaults.headers.post['lang'] = localStorage.getItem('blh5:lang') === 'en' ? 'en_US' : 'zh_CN'
  return config
})
/** 同步服务端时间
 *
 * @param {string} time
 */
const syncTime = ({ date }) => {
  console.log(88888888, date)
  // time / 2 降低误差
  let timeDifference = new Date(date).getTime() - new Date().getTime()
  let getTimeDifference = store.state.isTrans.timeDifference
  console.log(88888888, timeDifference, getTimeDifference)
  if (timeDifference === getTimeDifference) {
    return
  }
  if (timeDifference || (timeDifference === 0 && getTimeDifference !== 0)) {
    store.commit('set_timeDifference', timeDifference)
  }
}
export const logPost = async (data = {}, callback, errorCallback, catchCallback) => {
  let countNumObj = ''
  try {
    countNumObj = $utils.cache('bloom_call_num') && JSON.parse($utils.cache('bloom_call_num')) ? JSON.parse($utils.cache('bloom_call_num')) : ''
  } catch (error) {
    countNumObj = ''
  }
  if (countNumObj && countNumObj.callNum && countNumObj.curTime) {
    let countNum = countNumObj.callNum
    if ((new Date().getTime() - countNumObj.curTime) < 60000) {
      if (countNum > 50) {
        return
      } else {
        countNumObj.callNum = countNumObj.callNum + 1
        $utils.cache('bloom_call_num', JSON.stringify(countNumObj))
      }
    } else {
      countNumObj = { callNum: 1, curTime: new Date().getTime() }
      $utils.cache('bloom_call_num', JSON.stringify(countNumObj))
    }
  } else {
    countNumObj = { callNum: 1, curTime: new Date().getTime() }
    $utils.cache('bloom_call_num', JSON.stringify(countNumObj))
  }
  let url = apiConstant['REPROT_LOG_RECORD']
  url = '' + url
  axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
  axios.defaults.headers.post['ctype'] = ctype
  if ($utils.sessionCache('appSrc')) {
    axios.defaults.headers.post['appSrc'] = $utils.sessionCache('appSrc')
  }
  if (!data) {
    return
  }
  data.t = new Date().getTime()
  data.u = window.location.hash
  // console.log(window.location, 'window.location')
  let obj = {
    cType: ctype,
    lt: '1',
    logContent: data
  }
  axios.post(
    url,
    JSON.stringify(obj)
  ).catch((error) => {
    console.log(error)
  })
}
/**
 *
 * @param {string} constant url常量字符串
 * @param {object} data 参数对象
 * @param {function} callback 回调函数
 * @param {function} errorCallback 返回码不为0时的回调函数
 * @param {function} catchCallback 断网或网络问题时回调函数
 */
export const post = (constant, data = {}, callback, errorCallback, catchCallback) => {
  // console.log(Router, 'Router')
  // after('1')
  let title
  try {
    title = Router.currentRoute.query.taskTitle || ''
  } catch (e) {
    console.log(e)
  }
  let url = apiConstant[constant]
  url = '' + url
  store.commit('common_loading', true)
  axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
  axios.defaults.headers.post['ctype'] = ctype
  axios.defaults.headers.post['lang'] = localStorage.getItem('blh5:lang') === 'en' ? 'en_US' : 'zh_CN'
  if ($utils.sessionCache('appSrc')) {
    axios.defaults.headers.post['appSrc'] = $utils.sessionCache('appSrc')
  }
  if ($utils.isMiniProgram()) {
    // 先判断是不是小程序环境 是的话先换浏览器cookie的token
    if (window.location.href.includes('tokenStr')) {
      // 是小程序环境并且有tokenStr
      let param = getParam(window.location.href)
      let tokenStr = param.get('tokenStr')
      axios.defaults.headers.post['token'] = tokenStr
      setCookie('token', tokenStr)
    } else {

    }
  }
  axios.post(
    url,
    JSON.stringify(data)
  ).then((res) => {
    console.log(999999999999999999)
    syncTime(res.headers)
    store.commit('common_loading', false)
    if (res.data.code === 10016) {
      $utils.cache('loginState', null)
      if ($utils.getUserAgent()) {
        // console.log($utils.isMiniProgram())
        if ($utils.isMiniProgram()) {
          // { name: 'login', params: { fromPath: this.$Route.name, isTabbar: true  } }
          let uri
          if (window.location.href.includes('?tokenStr')) {
            uri = window.location.href.split('?tokenStr')[0]
          } else {
            uri = window.location.href.split('&tokenStr')[0]
          }
          window.wx && window.wx.miniProgram.redirectTo({ url: '/pagesB/login/index?fromH5Login=true&returnUrl=' + encodeURIComponent(uri) })
          return
        }
        if (document.getElementById('SimpleLogin')) return
        SimpleLogin.install()
      } else {
        $utils.appLogin()
      }
      // SignOut.installSignOut()      // 登录过期
    } else if (res.data.code === 10200) {
      typeof callback === 'function' && callback(res.data)
    } else if (res.data.code === 0) {
      typeof callback === 'function' && callback(res.data)
    } else if (res.data.code === 45101) {
      typeof errorCallback === 'function' && errorCallback(res.data)
    } else if (res.data.code === 45104) {
      Router.replace('/predecessors?title=' + title)
    } else {
      Message.installMessage(res.data.msg)
      typeof errorCallback === 'function' && callback(res.data)
    }
  }).catch((error) => {
    console.log(error)
    store.commit('common_loading', false)
    typeof catchCallback === 'function' && catchCallback(error)
  })
}
export const testpost = (constant, data = {}, callback, errorCallback, catchCallback) => {
  let url = constant
  url = '' + url
  store.commit('common_loading', true)
  axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
  axios.defaults.headers.post['ctype'] = ctype
  if ($utils.sessionCache('appSrc')) {
    axios.defaults.headers.post['appSrc'] = $utils.sessionCache('appSrc')
  }
  if ($utils.isMiniProgram()) {
    // 先判断是不是小程序环境 是的话先换浏览器cookie的token
    if (window.location.href.includes('tokenStr')) {
      // 是小程序环境并且有tokenStr
      let param = getParam(window.location.href)
      let tokenStr = param.get('tokenStr')
      axios.defaults.headers.post['token'] = tokenStr
      setCookie('token', tokenStr)
    } else {

    }
  }
  axios.post(
    url,
    JSON.stringify(data)
  ).then((res) => {
    syncTime(res.headers)
    store.commit('common_loading', false)
    if (res.data.code === 10016) {
      $utils.cache('loginState', null)
      if ($utils.getUserAgent()) {
        // console.log($utils.isMiniProgram())
        if ($utils.isMiniProgram()) {
          // { name: 'login', params: { fromPath: this.$Route.name, isTabbar: true  } }
          let uri
          if (window.location.href.includes('?tokenStr')) {
            uri = window.location.href.split('?tokenStr')[0]
          } else {
            uri = window.location.href.split('&tokenStr')[0]
          }
          window.wx && window.wx.miniProgram.redirectTo({ url: '/pagesB/login/index?fromH5Login=true&returnUrl=' + encodeURIComponent(uri) })
          return
        }
        if (document.getElementById('SimpleLogin')) return
        SimpleLogin.install()
      } else {
        $utils.appLogin()
      }
      // SignOut.installSignOut()      // 登录过期
    } else if (res.data.code === 10200) {
      typeof callback === 'function' && callback(res.data)
    } else if (res.data.code === 0) {
      typeof callback === 'function' && callback(res.data)
    } else {
      Message.installMessage(res.data.msg)
      typeof errorCallback === 'function' && callback(res.data)
    }
  }).catch((error) => {
    store.commit('common_loading', false)
    typeof catchCallback === 'function' && catchCallback(error)
  })
}

/**
 *
 * @param {string} constant url常量字符串
 * @param {object} data 参数对象
 * @param {function} callback 回调函数
 * @param {function} errorCallback 返回码不为0时的回调函数
 * @param {function} catchCallback 断网或网络问题时回调函数
 */
export const purePost = (constant, data = {}, callback, errorCallback, catchCallback) => {
  let title
  try {
    title = Router.currentRoute.query.taskTitle || ''
  } catch (e) {
    console.log(e)
  }
  let url = apiConstant[constant]
  url = '' + url
  axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
  axios.defaults.headers.post['ctype'] = ctype
  if ($utils.sessionCache('appSrc')) {
    axios.defaults.headers.post['appSrc'] = $utils.sessionCache('appSrc')
  }
  if ($utils.isMiniProgram()) {
    // 先判断是不是小程序环境 是的话先换浏览器cookie的token
    if (window.location.href.includes('tokenStr')) {
      // 是小程序环境并且有tokenStr
      let param = getParam(window.location.href)
      let tokenStr = param.get('tokenStr')
      setCookie('token', tokenStr)
    } else {

    }
  }
  axios.post(
    url,
    JSON.stringify(data)
  ).then((res) => {
    syncTime(res.headers)
    if (res.data.code === 10016) {
      $utils.cache('loginState', null)
      if ($utils.getUserAgent()) {
        if ($utils.isMiniProgram()) {
          // { name: 'login', params: { fromPath: this.$Route.name, isTabbar: true  } }
          let uri
          if (window.location.href.includes('?tokenStr')) {
            uri = window.location.href.split('?tokenStr')[0]
          } else {
            uri = window.location.href.split('&tokenStr')[0]
          }
          window.wx && window.wx.miniProgram.redirectTo({ url: '/pagesB/login/index?fromH5Login=true&returnUrl=' + encodeURIComponent(uri) })
          return
        }
        if (document.getElementById('SimpleLogin')) return
        SimpleLogin.install()
      } else {
        $utils.appLogin()
      }
      // SignOut.installSignOut()      // 登录过期
    } else if (res.data.code === 0) {
      typeof callback === 'function' && callback(res.data)
    } else if (res.data.code === 45104) {
      Router.replace('/predecessors?title=' + title)
    } else {
      typeof errorCallback === 'function' && callback(res.data)
    }
  }).catch((error) => {
    typeof catchCallback === 'function' && catchCallback(error)
  })
}
export const wxGet = (constant, data = {}, callback, errorCallback, catchCallback) => {
  let url = constant
  axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
  if ($utils.sessionCache('appSrc')) {
    axios.defaults.headers.post['appSrc'] = $utils.sessionCache('appSrc')
  }
  axios.get(
    url,
    // JSON.stringify(data)
    { params: data }
  ).then((res) => {
    syncTime(res.headers)
    if (res.data.code === 10016) {
      $utils.cache('loginState', null)
      if ($utils.getUserAgent()) {
        if ($utils.isMiniProgram()) {
          // { name: 'login', params: { fromPath: this.$Route.name, isTabbar: true  } }
          let uri
          if (window.location.href.includes('?tokenStr')) {
            uri = window.location.href.split('?tokenStr')[0]
          } else {
            uri = window.location.href.split('&tokenStr')[0]
          }
          window.wx && window.wx.miniProgram.redirectTo({ url: '/pagesB/login/index?fromH5Login=true&returnUrl=' + encodeURIComponent(uri) })
          return
        }
        if (document.getElementById('SimpleLogin')) return
        SimpleLogin.install()
      } else {
        $utils.appLogin()
      }
    } else if (res.data.code === 0) {
      typeof callback === 'function' && callback(res.data)
    } else {
      typeof errorCallback === 'function' && callback(res.data)
    }
  }).catch((error) => {
    typeof catchCallback === 'function' && catchCallback(error)
  })
}
export const pureGet = (constant, data = {}, callback, errorCallback, catchCallback) => {
  let url = apiConstant[constant]
  url = '' + url
  axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
  if ($utils.sessionCache('appSrc')) {
    axios.defaults.headers.post['appSrc'] = $utils.sessionCache('appSrc')
  }
  if ($utils.isMiniProgram()) {
    // 先判断是不是小程序环境 是的话先换浏览器cookie的token
    if (window.location.href.includes('tokenStr')) {
      // 是小程序环境并且有tokenStr
      let param = getParam(window.location.href)
      let tokenStr = param.get('tokenStr')
      axios.defaults.headers.post['token'] = tokenStr
      setCookie('token', tokenStr)
    } else {

    }
  }
  axios.get(
    url,
    // JSON.stringify(data)
    { params: data }
  ).then((res) => {
    syncTime(res.headers)
    if (res.data.code === 10016) {
      $utils.cache('loginState', null)
      if ($utils.getUserAgent()) {
        if ($utils.isMiniProgram()) {
          // { name: 'login', params: { fromPath: this.$Route.name, isTabbar: true  } }
          let uri
          if (window.location.href.includes('?tokenStr')) {
            uri = window.location.href.split('?tokenStr')[0]
          } else {
            uri = window.location.href.split('&tokenStr')[0]
          }
          window.wx && window.wx.miniProgram.redirectTo({ url: '/pagesB/login/index?fromH5Login=true&returnUrl=' + encodeURIComponent(uri) })
          return
        }
        if (document.getElementById('SimpleLogin')) return
        SimpleLogin.install()
      } else {
        $utils.appLogin()
      }
    } else if (res.data.code === 0) {
      typeof callback === 'function' && callback(res.data)
    } else {
      typeof errorCallback === 'function' && callback(res.data)
    }
  }).catch((error) => {
    typeof catchCallback === 'function' && catchCallback(error)
  })
}
export const newSaveBehavior = async (data = {}, callback, errorCallback, catchCallback) => {
  try {
    let url = apiConstant['INV_PROCTOR_SAVEEXAMTRANSACTION']
    url = '' + url
    axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
    axios.defaults.headers.post['ctype'] = ctype
    if ($utils.sessionCache('appSrc')) {
      axios.defaults.headers.post['appSrc'] = $utils.sessionCache('appSrc')
    }
    if (!data) {
      return
    }
    axios.post(
      url,
      data
    ).catch((error) => {
      console.log(error)
    })
  } catch (error) {

  }
}
export const file = (constant, data = {}, callback, errorCallback, catchCallback) => {
  let url = apiConstant[constant]
  axios.defaults.headers.post['Content-Type'] = 'multipart/form-data'
  if ($utils.sessionCache('appSrc')) {
    axios.defaults.headers.post['appSrc'] = $utils.sessionCache('appSrc')
  }
  axios.post(
    url,
    data
  ).then((res) => {
    syncTime(res.headers)
    if (res.data.code === 0) {
      typeof callback === 'function' && callback(res.data)
    } else if (res.data.code === 10016) {
      if ($utils.isMiniProgram()) {
        // { name: 'login', params: { fromPath: this.$Route.name, isTabbar: true  } }
        let uri
        if (window.location.href.includes('?tokenStr')) {
          uri = window.location.href.split('?tokenStr')[0]
        } else {
          uri = window.location.href.split('&tokenStr')[0]
        }
        console.log(uri, 'uri')
        window.wx && window.wx.miniProgram.redirectTo({ url: '/pagesB/login/index?fromH5Login=true&returnUrl=' + encodeURIComponent(uri) })
        return
      }
      $utils.cache('loginState', null)
      window.location.hash = '#/login'
    } else {
      console.log('1231313')
      Message.installMessage(res.data.msg)
      // Message({
      //   type: 'error',
      //   message: res.data.msg
      // })
      // Message({
      //   type: 'error',
      //   message: res.msg
      // })
      typeof errorCallback === 'function' && errorCallback(res.data)
    }
  }).catch((error) => {
    typeof catchCallback === 'function' && catchCallback(error)
  })
}

/**
 *
 * @param {string} constant url常量字符串
 * @param {object} data 参数对象
 * @param {function} callback 回调函数
 * @param {function} errorCallback 返回码不为0时的回调函数
 * @param {function} catchCallback 断网或网络问题时回调函数
 */
export const simplePost = (constant, data = {}, callback, errorCallback, catchCallback) => {
  let title
  try {
    title = Router.currentRoute.query.taskTitle || ''
  } catch (e) {
    console.log(e)
  }
  let url = apiConstant[constant]
  url = '' + url
  axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
  axios.defaults.headers.post['ctype'] = ctype
  if ($utils.sessionCache('appSrc')) {
    axios.defaults.headers.post['appSrc'] = $utils.sessionCache('appSrc')
  }
  if ($utils.isMiniProgram()) {
    // 先判断是不是小程序环境 是的话先换浏览器cookie的token
    if (window.location.href.includes('tokenStr')) {
      // 是小程序环境并且有tokenStr
      let param = getParam(window.location.href)
      let tokenStr = param.get('tokenStr')
      axios.defaults.headers.post['token'] = tokenStr
      setCookie('token', tokenStr)
    } else {

    }
  }
  axios.post(
    url,
    JSON.stringify(data)
  ).then((res) => {
    syncTime(res.headers)
    if (res.data.code === 10016) {
      $utils.cache('userData', null)
      $utils.cache('loginState', null)
      // SignOut.installSignOut()      // 登录过期
    } else if (res.data.code === 0) {
      typeof callback === 'function' && callback(res.data)
    } else if (res.data.code === 45104) {
      Router.replace('/predecessors?title=' + title)
    } else {
      typeof errorCallback === 'function' && callback(res.data)
    }
  }).catch((error) => {
    typeof catchCallback === 'function' && catchCallback(error)
  })
}

/**
 *
 * @param {string} constant url常量字符串
 * @param {object} data 参数对象
 * @param {function} callback 回调函数
 * @param {function} errorCallback 返回码不为0时的回调函数
 * @param {function} catchCallback 断网或网络问题时回调函数
 */
export const singlePost = (url, data = {}, callback, errorCallback, catchCallback) => {
  let title
  try {
    title = Router.currentRoute.query.taskTitle || ''
  } catch (e) {
    console.log(e)
  }
  axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
  axios.defaults.headers.post['ctype'] = ctype
  if ($utils.sessionCache('appSrc')) {
    axios.defaults.headers.post['appSrc'] = $utils.sessionCache('appSrc')
  }
  if ($utils.isMiniProgram()) {
    // 先判断是不是小程序环境 是的话先换浏览器cookie的token
    if (window.location.href.includes('tokenStr')) {
      // 是小程序环境并且有tokenStr
      let param = getParam(window.location.href)
      let tokenStr = param.get('tokenStr')
      axios.defaults.headers.post['token'] = tokenStr
      setCookie('token', tokenStr)
    } else {

    }
  }
  axios.post(
    url,
    JSON.stringify(data)
  ).then((res) => {
    syncTime(res.headers)
    if (res.data.code === 10016) {
      $utils.cache('userData', null)
      $utils.cache('loginState', null)
      // SignOut.installSignOut()      // 登录过期
    } else if (res.data.code === 45104) {
      Router.replace('/predecessors?title=' + title)
    } else if (res.data.code === 0) {
      typeof callback === 'function' && callback(res.data)
    } else {
      typeof errorCallback === 'function' && callback(res.data)
    }
  }).catch((error) => {
    typeof catchCallback === 'function' && catchCallback(error)
  })
}



// WEBPACK FOOTER //
// ./src/assets/api/index.js